import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const ProcessingStatus = ({ stage, progress, fileName }) => {
  const { t } = useTranslation();
  
  const stages = [
    { label: t('pdfUpload.processing.stages.uploading'), icon: 'Upload', threshold: 20 },
    { label: t('pdfUpload.processing.stages.parsing'), icon: 'FileSearch', threshold: 40 },
    { label: t('pdfUpload.processing.stages.extracting'), icon: 'Layers', threshold: 60 },
    { label: t('pdfUpload.processing.stages.optimizing'), icon: 'Sparkles', threshold: 80 }
  ];

  const getStageStatus = (threshold) => {
    if (progress >= threshold) return 'complete';
    if (progress >= threshold - 20) return 'active';
    return 'pending';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-elevation-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center">
          <Icon name="FileText" size={20} className="text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-foreground truncate">{fileName}</h3>
          <p className="text-xs text-muted-foreground">{stage}</p>
        </div>
        <div className="text-sm font-semibold text-accent">{progress}%</div>
      </div>

      {/* Progress Bar */}
      <div className="relative h-2 bg-muted rounded-full overflow-hidden mb-6">
        <div
          className="absolute inset-y-0 left-0 bg-accent transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Stage Indicators */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stages?.map((stageItem, index) => {
          const status = getStageStatus(stageItem?.threshold);
          return (
            <div
              key={index}
              className={`
                flex flex-col items-center gap-2 p-3 rounded-lg transition-all duration-250
                ${status === 'complete' ? 'bg-success/10' : ''}
                ${status === 'active' ? 'bg-accent/10' : ''}
                ${status === 'pending' ? 'bg-muted/50' : ''}
              `}
            >
              <div className={`
                w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-250
                ${status === 'complete' ? 'bg-success text-success-foreground' : ''}
                ${status === 'active' ? 'bg-accent text-accent-foreground' : ''}
                ${status === 'pending' ? 'bg-muted text-muted-foreground' : ''}
              `}>
                {status === 'complete' ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <Icon name={stageItem?.icon} size={16} />
                )}
              </div>
              <span className={`
                text-xs font-medium text-center
                ${status === 'complete' ? 'text-success' : ''}
                ${status === 'active' ? 'text-accent' : ''}
                ${status === 'pending' ? 'text-muted-foreground' : ''}
              `}>
                {stageItem?.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Estimated Time */}
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground">
          {progress < 100 ? t('pdfUpload.processing.processingCatalog') : t('pdfUpload.processing.processingComplete')}
        </p>
      </div>
    </div>
  );
};

export default ProcessingStatus;